import { Invoice } from './types';

export const formatCurrency = (amount: number): string => {
  return amount.toLocaleString('sv-SE', { minimumFractionDigits: 0, maximumFractionDigits: 0 }) + ' kr';
};

export const getStatusBadge = (status: Invoice['status']) => {
  switch (status) {
    case 'draft':
      return <span className="px-2 py-1 text-xs rounded-full bg-slate-100 text-slate-600">Utkast</span>;
    case 'sent':
      return <span className="px-2 py-1 text-xs rounded-full bg-blue-100 text-blue-700">Skickad</span>;
    case 'paid':
      return <span className="px-2 py-1 text-xs rounded-full bg-green-100 text-green-700">Betald</span>;
    case 'overdue':
      return <span className="px-2 py-1 text-xs rounded-full bg-red-100 text-red-700">Förfallen</span>;
  }
};

export const getFrequencyLabel = (frequency: string): string => {
  switch (frequency) {
    case 'monthly': return 'Månadsvis';
    case 'quarterly': return 'Kvartalsvis';
    case 'yearly': return 'Årsvis';
    case 'once': return 'Engångs';
    default: return frequency;
  }
};

export const getDistributionLabel = (method: string): string => {
  switch (method) {
    case 'equal': return 'Lika';
    case 'by_sqm': return 'Per kvm';
    case 'by_shares': return 'Per andel';
    default: return method;
  }
};
